<template>
  <div ref="pdfContent">
    <Layout ref="layoutRef" :selectedOption="2" />
    <div class="container d-flex justify-content-between">
      <div class="breadcrumb-container">
        <router-link to="/agrupados-por-forma-pago">Pagos Agrupados por Forma de Pago</router-link>
        > {{ p_formaPago }}
      </div>
    </div>
    <hr>

    <div class="mb-3">
      <div class="input-group">
        <span class="input-group-text">Desde:</span>
        <input type="date" class="form-control" v-model="p_fechaDesde" disabled>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span class="input-group-text">Hasta:</span>
        <input type="date" class="form-control" v-model="p_fechaHasta" disabled>
        <button @click="exportToPDF" class="btn btn-outline-danger">Exportar a PDF</button>
        <button @click="exportToCSV" class="btn btn-outline-success">Exportar a CSV</button>
      </div>
    </div>

    <DataTable
      :data="pagos"
      :columns="columnas"
      idField="idPago"
      :acciones="false"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="false"
      :mostrarBotonExcel="false"
      mensajeVacio="No hay pagos para el período seleccionado."
    >
      <template #cell-monto="{ row }">
        <span class="d-block text-end">{{ row.monto }}</span>
      </template>

      <!-- Total en la barra superior -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-2 ms-2">
          <span class="small fw-bold">
            Total monto: <strong>{{ totalMonto }}</strong>
          </span>
        </div>
      </template>
    </DataTable>

    <Footer />
  </div>
</template>

<script>
import Layout    from '@/components/Layout.vue'
import Footer    from '@/components/Footer.vue'
import DataTable from '@/components/DataTable.vue'
import api       from "@/services/api"
import { ref }   from 'vue'
import html2canvas from 'html2canvas'
import { jsPDF }   from 'jspdf'

export default {
  components: { Layout, Footer, DataTable },
  data() {
    return {
      pagos:         [],
      p_idFormaPago: 0,
      p_formaPago:   '',
      p_fechaDesde:  '',
      p_fechaHasta:  '',
    }
  },
  computed: {
    // Columna Aseguradora solo aparece cuando idFormaPago === 5
    columnas() {
      const base = [
        { field: 'personaNombre',    label: 'Persona'   },
        { field: 'personaDocumento', label: 'Documento' },
        { field: 'personaEmail',     label: 'Email'     },
        { field: 'monto',            label: 'Monto',    numeric: true },
        { field: 'referencia',       label: 'Referencia' },
      ]
      if (String(this.p_idFormaPago) === '5') {
        return [
          { field: 'aseguradorNombre', label: 'Aseguradora' },
          ...base,
        ]
      }
      return base
    },
    totalMonto() {
      return this.pagos.reduce((t, p) => t + p.monto, 0)
    },
  },
  setup() {
    const pdfContent = ref(null)
    const exportToPDF = async () => {
      if (pdfContent.value) {
        const canvas  = await html2canvas(pdfContent.value)
        const imgData = canvas.toDataURL('image/png')
        const pdf     = new jsPDF({
          orientation: 'landscape',
          unit:        'px',
          format:      [canvas.width, canvas.height],
        })
        pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height)
        pdf.save('detalle_forma_pago.pdf')
      }
    }
    return { pdfContent, exportToPDF }
  },
  async mounted() {
    this.p_idFormaPago = this.$route.params.p_idformapago
    this.p_formaPago   = this.$route.params.p_formapago
    this.p_fechaDesde  = this.$route.params.p_fechadesde
    this.p_fechaHasta  = this.$route.params.p_fechahasta
    await this.fetchPagos()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods: {
    async fetchPagos() {
      try {
        const idEmpresa   = window.sessionStorage.getItem("idEmpresa")
        const response    = await api.get('/vwpagoexts/forma-pago', {
          params: {
            idEmpresa,
            idFormaPago: this.p_idFormaPago,
            fechaDesde:  this.p_fechaDesde,
            fechaHasta:  this.p_fechaHasta,
          },
        })
        this.pagos = response.data
      } catch (error) {
        console.error("Error fetching pagos:", error)
      }
    },
    exportToCSV() {
      let csv = "data:text/csv;charset=utf-8,"
      csv += `Forma Pago:, ${this.p_formaPago}\n`
      csv += `Fecha desde:, ${this.p_fechaDesde}\n`
      csv += `Fecha hasta:, ${this.p_fechaHasta}\n`
      csv += "Aseguradora,Persona,Documento,Email,Monto,Referencia\n"
      this.pagos.forEach(p => {
        csv += `${p.aseguradorNombre},${p.personaNombre},${p.personaDocumento},${p.personaEmail},${p.monto},${p.referencia}\r\n`
      })
      csv += `,,,Total,${this.totalMonto},\n`
      const link = document.createElement("a")
      link.setAttribute("href", encodeURI(csv))
      link.setAttribute("download", `pagos_${this.p_formaPago}.csv`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },
}
</script>

<style scoped>
.table-hover tbody tr:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}
</style>